import { render, staticRenderFns } from "./FieldZone.vue?vue&type=template&id=651d3f34&"
import script from "./FieldZone.vue?vue&type=script&lang=js&"
export * from "./FieldZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports